import { useEffect, useState } from 'react';
import useUser from '../providers/userProvider';

/**
 * Custom hook to be used on the client side and that is about to determine
 * if the present logged in user is a club member.
 *
 * @returns {boolean} - True if user is a club member, false otherwise.
 */
export const useIsClubMember = (): boolean => {
  const [isClubMember, setIsClubMember] = useState(false);

  const { customer } = useUser();

  useEffect(() => {
    if (customer?.isClubMember()) {
      setIsClubMember(true);
      return;
    }
    setIsClubMember(false);
  }, [customer]);

  return isClubMember;
};
